import React from 'react'
import python from '../assets/python.png'
import javascript from '../assets/javascript.png'
import react from '../assets/react.png'
import tailwind from '../assets/tailwind.png'
import swift from '../assets/swift.png'
import java from '../assets/java.png'
import cpp from '../assets/c++.png'
import haskell from '../assets/haskell.png'

const Skills = () => {
  return (<div className='max-w-[1200px] mx-auto p-5' id='skills'>
        <h2 className='text-gray-700 text-4xl md:text-4xl font-bold my-4 primary-color'>
                My Tech Stack
        </h2>
        <div className='border-gray-600 bg-black text-gray-400 md:h-[150px] max-w-[1200px] mx-auto grid md:grid-cols-8 grid-cols-4 place-items-center
                        md:flex md:justify-between md:items-center mt-0 md:mt-4 lg:mt-8 '>

            <div className='flex flex-col my-5 items-center w-[80px] md:w-[100px] border border-gray-600 p-4 rounded-xl hover:ring-2 ring-offset-30 ring-blue-600 hover:scale-125 transition duration-300'>
                <img src={python} alt="python" className='w-16 h-16 object-contain' />
                <p className='mt-2 text-center'>Python</p>
            </div>

            <div className='flex flex-col my-5 items-center w-[80px] md:w-[100px] border border-gray-600 p-4 rounded-xl hover:ring-2 ring-offset-30 ring-blue-600 hover:scale-125 transition duration-300'>
                <img src={javascript} alt="javascript" className='w-16 h-16 object-contain rounded-xl' />
                <p className='mt-2 text-center'>Javascript</p>
            </div>

            <div className='flex flex-col my-5 items-center w-[80px] md:w-[100px] border border-gray-600 p-4 rounded-xl hover:ring-2 ring-offset-30 ring-blue-600 hover:scale-125 transition duration-300'>
                <img src={react} alt="react" className='w-16 h-16 object-contain' />
                <p className='mt-2 text-center'>React</p>
            </div>

            <div className='flex flex-col my-5 items-center w-[80px] md:w-[100px] border border-gray-600 p-4 rounded-xl hover:ring-2 ring-offset-30 ring-blue-600 hover:scale-125 transition duration-300'>
                <img src={tailwind} alt="tailwind" className='w-16 h-16 object-contain' />
                <p className='mt-2 text-center'>Tailwind</p>
            </div>

            <div className='flex flex-col my-5 items-center w-[80px] md:w-[100px] border border-gray-600 p-4 rounded-xl hover:ring-2 ring-offset-30 ring-blue-600 hover:scale-125 transition duration-300'>
                <img src={swift} alt="swift" className='w-16 h-16 object-contain' />
                <p className='mt-2 text-center'>Swift</p>
            </div>  

            <div className='flex flex-col my-5 items-center w-[80px] md:w-[100px] border border-gray-600 p-4 rounded-xl hover:ring-2 ring-offset-30 ring-blue-600 hover:scale-125 transition duration-300'>
                <img src={java} alt="java" className='w-16 h-16 object-contain' />
                <p className='mt-2 text-center'>Java</p>
            </div>

            <div className='flex flex-col my-5 items-center w-[80px] md:w-[100px] border border-gray-600 p-4 rounded-xl hover:ring-2 ring-offset-30 ring-blue-600 hover:scale-125 transition duration-300'>
                <img src={cpp} alt="cpp" className='w-16 h-16 object-contain' />
                <p className='mt-2 text-center'>C++</p>
            </div>

            <div className='flex flex-col my-5 items-center w-[80px] md:w-[100px] border border-gray-600 p-4 rounded-xl hover:ring-2 ring-offset-30 ring-blue-600 hover:scale-125 transition duration-300'>
                <img src={haskell} alt="haskell" className='w-16 h-16 object-contain' />
                <p className='mt-2 text-center'>Haskell</p>
            </div>
        </div>
    </div>
  )
}

export default Skills